module.exports = __webpack_public_path__ + "img/1.720ef18c.jpg";